<template>
  <div class="prizewinner">
    <h1>中奖名单公示</h1>
    <div class="winner_list">
      <div class="winner_item" v-for="item in winner_list">
        <div class="item_line clear-fix">
          <p class="item_left">
            中奖人：
          </p>
          <p class="item_right">
            {{item.name}}
          </p>
        </div>
        <div class="item_line clear-fix">
          <p class="item_left">
            联系方式：
          </p>
          <p class="item_right">
            {{item.tel}}
          </p>
        </div>
        <div class="item_line clear-fix">
          <p class="item_left">
            竞猜项目：
          </p>
          <p class="item_right">
            {{item.guess_name}}
          </p>
        </div>
        <div class="item_line clear-fix">
          <p class="item_left">
            奖品：
          </p>
          <p class="item_right">
            {{item.prize}}
          </p>
        </div>
        <div class="item_line clear-fix">
          <p class="item_left">
            竞猜结果：
          </p>
          <p class="item_right">
            {{item.final_result}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Prizewinner",
        data() {
            return {
                winner_list: []
            }
        },
        created() {
            this.getWinnerList();
        },
        methods: {
            getWinnerList() {
                this.$axios({
                    url: 'https://api.hainanfa.org.cn/guess/result',
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    }
                }).then(res => {
                    this.winner_list = res.data.data
                    console.log(res)
                }).catch(err => {
                    console.log(err);
                })
            },
        }
    }
</script>

<style scoped>

.prizewinner{
  line-height: 1.2em;
  padding: 0 10px;
}
.prizewinner h1{
  line-height: 1.5em;
  color: #333333;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0;
}
.winner_list{
  padding-bottom: 50px;
}
.winner_list .winner_item:last-of-type{
  border-bottom: none;
}
.winner_item{
  padding: 8px 0 20px;
  border-bottom: 1px solid #666666;
}
  .item_line{
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #000000;
    margin-top: 12px;
  }
.item_line .item_left{
  align-self: flex-start;
}
  .item_line .item_right{
    flex: 1;
  }
</style>
